import { gql } from '@src/__generated__';

export const UPDATE_OBJECT_PROPERTY = gql(/* GraphQL */ `
  mutation UpdateObjectWithProperties($input: UpdateObjectWithPropertiesInput!) {
    updateObjectWithProperties(input: $input) {
      clientMutationId
    }
  }
`);
